/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "lib/commons/registry";
import "lib/commons/basis_Perms";

const r = REG.reg;
r.newPerm("dowload.wspPack", "adminSyst", 0);
r.newPerm("install.wspPack", "deploy", 0);
r.newPerm("list.wspPacks", "admin", 0);
r.newPerm("install.skinPack", "admin", 0);
r.newPerm("show.skinPack", "admin", 0);
r.newPerm("admin.wsp", "admin", 0);
r.newPerm("exportConfig.wsps", "admin", 0);
r.newPerm("exportConfig.roles", "admin", 0);
r.newPerm("read.wsp", "read", 0);
r.newPerm("reload.wsp", "admin", 0);
r.newPerm("remove.cache.wsp", "admin", 0);
r.newPerm("use.wsp", "use", 0);
r.newPerm("read.wspInTrash", "read", 0);
r.newPerm("admin.node", "admin", 0);
r.newPerm("read.node.copyFrom", "read", 0);
r.newPerm("read.node", "read", 0);
r.newPerm("write.node", "write", 0);
r.newPerm("use.packs", "use", 0);
r.newPerm("uninstall.wspPack", "list.wspPacks", 0);
r.newPerm("delete.skinPack", "install.skinPack", 0);
r.newPerm("download.skinPack", "show.skinPack", 0);
r.newPerm("create.wsp", "admin.wsp", 0);
r.newPerm("delete.wsp", "admin.wsp", 0);
r.newPerm("list.wsps", "use.wsp", 0);
r.newPerm("update.wsp", "admin.wsp", 0);
r.newPerm("read.repos.task", "use.wsp", 0);
r.newPerm("admin.wspInTrash", "admin.wsp", 0);
r.newPerm("list.wspsInTrash", "use.wsp", 0);
r.newPerm("read.gen", "read.node", 0);
r.newPerm("admin.node.configRoles", "admin.node", 0);
r.newPerm("admin.node.configRoles.byAdmin", "admin.node", 0);
r.newPerm("read.node.export", "read.node", 0);
r.newPerm("read.node.copyFrom.interWsp", "read.node.copyFrom", 0);
r.newPerm("read.node.web", "read.node", 0);
r.newPerm("read.node.search", "read.node", 0);
r.newPerm("read.node.reveal", "read.node", 0);
r.newPerm("write.node.copyTo", "write.node", 0);
r.newPerm("write.node.create", "write.node", 0);
r.newPerm("write.node.delete", "write.node", 0);
r.newPerm("write.node.duplicate", "write.node", 0);
r.newPerm("write.node.import", "write.node", 0);
r.newPerm("write.node.moveFrom", "write.node", 256);
r.newPerm("write.node.moveTo", "write.node", 0);
r.newPerm("write.node.rename", "write.node", 256);
r.newPerm("write.node.setMeta", "write.node", 0);
r.newPerm("write.node.update", "write.node", 0);
r.newPerm("callTransition.item", "write.node", 4);
r.newPerm("write.item.resp", "write.node", 0);
r.newPerm("commit.drf", "write.node", 0);
r.newPerm("revert.drf", "write.node", 0);
r.newPerm("delete.drvOverride", "write.node", 0);
r.newPerm("mark.drvOverrideDone", "write.node", 0);
r.newPerm("deletePermanently.history", "write.node", 0);
r.newPerm("read.history", "read.node", 0);
r.newPerm("restore.history", "write.node", 0);
r.newPerm("deletePermanently.trash", "write.node", 0);
r.newPerm("read.trash", "read.node", 0);
r.newPerm("restore.trash", "write.node", 0);
r.newPerm("read.task", "read.node", 0);
r.newPerm("read.task.search", "read.node", 0);
r.newPerm("write.task", "write.node", 0);
r.newPerm("create.version", "write.node", 0);
r.newPerm("read.version", "read.node", 0);
r.newPerm("create.wsp.import", "create.wsp", 0);
r.newPerm("migrate.wsp", "update.wsp", 0);
r.newPerm("deletePermanently.wspInTrash", "admin.wspInTrash", 0);
r.newPerm("restore.wspInTrash", "admin.wspInTrash", 0);
r.newPerm("create.wsp.drf", "create.wsp", 0);
r.newPerm("create.wsp.drv", "create.wsp", 0);
r.newPerm("generate", "read.gen", 0);
r.newPerm("store.genProps", "read.gen", 0);
r.newPerm("write.node.copyTo.interWsp", "write.node.copyTo", 0);
r.newPerm("write.node.convert", "write.node.update", 0);
r.newPerm("create.item", "write.node.create", 0);
r.newPerm("rename.item", "write.node.rename", 0);
r.newPerm("create.space", "write.node.create", 0);
r.newPerm("rename.space", "write.node.rename", 0);
r.newPerm("moveFrom.item.toAir", "write.node.moveFrom", 0);
r.newPerm("update.outsideLayer", "commit.drf", 0);
r.newPerm("write.task.create", "write.task", 0);
r.newPerm("write.task.delete", "write.task", 0);
r.newPerm("write.task.update", "write.task", 0);
r.newPerm("create.airItem", "create.item", 0);
